import React, { Fragment } from 'react'
import clsx from 'clsx'
import { Info as InfoIcon } from 'react-feather'
import { Box, Chip, Divider, Tooltip, Typography } from '@material-ui/core'

import useStyles from './styles'
import theme from 'theme'

const WhiteTooltip = ({
  children,
  tooltipClasses,
  arrowClasses,
  aiAlert,
  containerProps = {},
  cursor,
  ...rest
}) => {
  const classes = useStyles()

  return (
    <Tooltip
      {...rest}
      classes={{
        tooltip: clsx(classes.whiteTooltip, tooltipClasses),
        ...(rest.arrow && {
          arrow: clsx(classes.whiteTooltipArrow, arrowClasses),
        }),
      }}
      title={
        <Box>
          {aiAlert && (
            <Fragment>
              <Box
                display="flex"
                flexDirection="column"
                gridGap={theme.spacing(1)}
                p={1}
              >
                <Box
                  display="flex"
                  gridGap={theme.spacing(1)}
                  alignItems="center"
                >
                  <InfoIcon size={16} className={classes.daiInfo} />
                  <Typography variant="subtitle2" className={classes.daiInfo}>
                    Funcionalidade em Beta
                  </Typography>
                  <Chip label="Beta" size="small" className={classes.daiChip} />
                </Box>
                <Typography variant="body2">
                  Os conteúdos, análises e recomendações gerados por esta
                  Inteligência Artificial encontram-se em versão beta e são
                  produzidos de forma automatizada. Embora a tecnologia
                  empregada busque precisão e qualidade, podem ocorrer erros,
                  imprecisões ou interpretações incorretas. A pré-análise
                  fornecida pela IA possui caráter&nbsp;
                  <strong>apenas indicativo</strong> e{' '}
                  <strong>não garante</strong>
                  &nbsp; que os resultados finais da avaliação sejam alcançados.
                  Todos os resultados&nbsp;
                  <strong>
                    devem ser revisados e validados por um profissional
                  </strong>
                  , não devendo ser utilizados sem supervisão humana. Para mais
                  informações, consulte nossas políticas.
                </Typography>
              </Box>
              {!!rest?.title && <Divider />}
            </Fragment>
          )}
          {!!rest?.title && (
            <Box
              display="flex"
              flexDirection="column"
              gridGap={theme.spacing(1)}
              p={1}
              {...containerProps}
            >
              {rest?.title}
            </Box>
          )}
        </Box>
      }
    >
      <span
        style={{
          ...(cursor && { cursor }),
          ...rest?.style,
        }}
      >
        {children}
      </span>
    </Tooltip>
  )
}

export default WhiteTooltip
